import React, { useState, useEffect } from 'react';
import styles from '../../Style/Metadata.module.scss';
import { Empty, Tabs } from 'antd';
import { IDatasetMetadata } from '../../../../typings/metadata';
import MetadataList from './MetadataList';
import Api from '../../../../api/Api';
import { Loading } from '../../../../components/Loading/Loading';

export default function SearchMetadata(props: { options: string }) {
  const { options } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false)

  const [metadata, setMetadata] = useState<IDatasetMetadata>(() =>
    emptyMetaData()
  );

  useEffect(() => {
    setMetadata(emptyMetaData());
    doMetadataUpdate(options);
  }, [options]);

  function emptyMetaData() {
    return {
      general: {},
      coverage: {},
      variable: {},
    };
  }

  const doMetadataUpdate = async (name: string) => {
    setLoading(true);
    setError(false)
    try {
      const metadata = await Api.detail.searchDatasetDetail(name);

      const general: { [key: string]: any } = {};
      const coverage: { [key: string]: any } = {};
      const variable: { [key: string]: any } = {};

      Object.entries(metadata).forEach(([key, value]) => {
        const [prefix, ...rest] = key.split('_');
        const suffix = rest.join('_');

        if (prefix) {
          switch (prefix.toLowerCase()) {
            case 'general':
              general[suffix] = value;
              break;
            case 'coverage':
              coverage[suffix] = value;
              break;
            case 'variables':
              variable[suffix] = value;
              break;
          }
        }
      });

      setMetadata({ general, coverage, variable });
    } catch (error) {
      setError(true)
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.root}>
      <Loading loading={loading}></Loading>
      {error && <Empty />}

      {!error && <Tabs defaultActiveKey="1" className={styles.flexTabs}>
        <Tabs.TabPane tab="General" key="1">
          <MetadataList data={metadata.general} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Coverage" key="2">
          <MetadataList data={metadata.coverage} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Variables" key="3">
          <MetadataList data={metadata.variable} />
        </Tabs.TabPane>
      </Tabs>
      }
    </div>
  );
}
